<template>
  <div class="leaf-course">
    <div class="class_block" v-for="i in list" :key="i.id">
      <p class="tit">{{i.title}}</p>
      <div class="parent-list" v-for="item in i.children" :key="item.id">
        <div class="com-child" @click.stop="judgetype(item, coding)" v-if="item.module_type == 1 || (item.module_type == 19 && item.type == 3)">
          <p><img src="../../../static/images/doc.png" class="doc" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">
              <span>文档</span> <span class="placeline"></span> {{ item.file_size }}M
            </p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item, coding)" v-if="item.module_type == 19 && (item.type == 0 || item.type == 1)">
          <p><img src="../../../static/images/doc.png" class="doc" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">
              <span>作业</span>  <span class="placeline"></span> {{ item.file_size }}M
            </p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item, coding)" v-if="item.module_type == 2 || (item.module_type == 19 && item.type == 2)">
          <p><img src="../../../static/images/video.png" class="video" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">
              视频<span v-if="item.video_time"> <span class="placeline"></span> {{ item.video_time | formatSeconds }}</span>
            </p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item)" v-if="item.module_type == 4 || (item.module_type == 19 && item.type == 8)">
          <p><img src="../../../static/images/write.png" class="write" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">试卷</p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item)" v-if="item.module_type == 5 || (item.module_type == 19 && item.type == 4)">
          <p><img src="../../../static/images/write.png" class="write" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">练习</p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item, coding)" v-if="item.module_type == 6 && item.is_playback == 1">
          <p><img src="../../../static/images/playback.png" class="video" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">
              回放  <span v-if="(goodsType != 6 && goodsType != 10) || item.is_show_time"><span class="placeline"></span> {{ item.start_time | timeFormat }} - {{ item.end_time | localDateH }}</span>
            </p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item, coding)" v-else-if="item.module_type == 6 || (item.module_type == 19 && item.type == 6)">
          <p><img src="../../../static/images/zhibo.png" class="write" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">
              直播  <span v-if="(goodsType != 6 && goodsType != 10) || item.is_show_time"><span class="placeline"></span> {{ item.start_time | timeFormat }} - {{ item.end_time | localDateH }}</span>
            </p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item, coding)" v-if="item.module_type == 7 || (item.module_type == 19 && item.type == 7)">
          <p><img src="../../../static/images/handout.png" class="handout" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">讲义夹</p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item, coding)" v-if="item.module_type == 20 || (item.module_type == 19 && item.type == 20)">
          <p><img src="../../../static/images/dryRun.png" class="handout" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">模考</p>
          </div>
        </div>
        <div class="com-child" @click.stop="judgetype(item)" v-if="item.module_type == 9">
          <p><img src="../../../static/images/zhibo.png" class="write" alt /></p>
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="other-msg">
              直播  <span v-if="(goodsType != 6 && goodsType != 10) || item.is_show_time"><span class="placeline"></span> {{ item.start_time | timeFormat }} - {{ item.end_time | localDateH }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="handout_assembly" v-show='handout_flag' @click.stop="parent">
      <handoutFile @child="parent" :files="handoutlist" :cid='coding' :packageid='package_id' class="handout_content"></handoutFile>
    </div>
    <popup :data='detail' :type='1' @isopen="popup" class="popop_content" v-if='applets_flag&&ios'></popup>
    <popup :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&android'></popup>
    <div class="class_dialog" v-if="zujian_flag">
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{appname}}APP"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
            id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid="appid"
            :extinfo="JSON.stringify({'type': 1, 'spuID': shopid, 'orderSn': sn, 'owner': this.$route.query.owner, 'channel': this.$route.query.channel, 'orgn': this.$route.query.orgn})"
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
			         </style>
               <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
          <span v-if='android' class="goapp"><a :href="scheme + '?type=1&sso_id='+ ssoid +'&orderSn='+ sn + '&spuID='+ shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn" @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
        </p>
      </div>
    </div>
    <goapp @openapp='goapp' v-if="zujians_flag" :data='detail'></goapp>
    <arouse v-if="arshow" @arouse='receive'></arouse>
  </div>
</template>
<script>
import handoutFile from "../handout/index"; //讲义
import goapp from "../popup/goapp" //打开APP
import popup from "../popup/index" //小程序弹窗
import localDateH from "../../utils/localDate.js";
import timeFormat from "../../utils/timeFormat.js";
import formatSeconds from "../../utils/formatSecond.js";
import arouse from '../arouse/index.vue'
import { Toast } from "vant";

export default {
  data() {
    return {
      ticket: JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
      ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      list: [],
      package_id: '',
      coding: '',
      handoutlist: [],
      handout_flag: false,
      zujian_flag: false,
      zujians_flag: false,
      detail: '',
      ssoid: localStorage.getItem("ticketObj")?JSON.parse(localStorage.getItem("ticketObj")).sso_id:'',
      ua: navigator.userAgent.toLowerCase(),
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iPod/),
      sn: this.$route.query.order_id,
      shopid: '',
      applets_flag: false,
      isapplets: false,
      appid: '',
      sf: '',
      appname: '',
      scheme: '',
      isweixin: false,
      arshow: false,
      goodsType: ''
    }
  },
  props: ["dataList"],
  components: {
    handoutFile,
    popup,
    goapp,
    arouse
  },
  filters: {
    formatSeconds: function (value) {
      return formatSeconds(value);
    },
    timeFormat: function (value) {
      return timeFormat(value);
    },
    localDateH: function (value) {
      return localDateH(value);
    }
  },
  mounted() {
    // 小程序内
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isapplets = true
      }
    })
    this.getDetail()
    this.sf = this.$route.query.sf
    if (this.sf == 'zxkt') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '在线课堂'
      this.scheme = 'zaixianketang://'
    } else if (this.sf == 'zgwx') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.scheme = 'zaixianketang://'
    } else if (this.sf == 'sydw') {
      this.appid = 'wx4161c8d806017e0d'
      this.appname = '事业单位'
      this.scheme = 'shiyedanwei://'
    } else if (this.sf == 'zgtk') {
      this.appname = '中公题库'
    } else if (this.sf == 'zgzsb') {
      this.appid = 'wx9487d9bc65834b47'
      this.appname = '中公专升本'
      this.scheme = 'zhonggongzhuanshengben://openapp'
    } else if (this.sf == 'zgyljy'){
      this.appid = 'wxc7238886c470203e'
      this.appname = '中公医疗教育'
      this.scheme = 'zhonggongyiliaojiaoyu://openapp'
    } else if (this.sf == 'zgjsgc') {
      this.appname = '中公建设工程'
    } else if (this.sf == 'zgyouzhi') {
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
  },
  methods: {
    receive (val) {
      this.arshow = val
    },
    handleErrorFn(e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("当前手机未下载中公教育app");
      // this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      if (this.sf == 'sydw') {
        window.location.href ="https://xue.offcn.com/institution/";
      } else if (this.sf == 'zgwx') {
        window.location.href ="https://www.eoffcn.com/help/download/online_course.html";
      } else if (this.sf == 'zgzsb') {
        window.location.href ="https://www.offcnzsb.com/zg/scan/";
      } else {
        //判断iPhone|iPad|iPod|iOS
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
        } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
        }
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      );
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
    getDetail () {
      this.$api.GETDETAIL({
        system_order_num: this.$route.query.order_id,
        "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      }).then((res) => {
        if (res.code == 0) {
          this.shopid = res.data.goodsId
          this.goodsType = res.data.goodsType
          this.getLessonInfo()
        } else if (res.code == 2 || res.code == 4) {
          sso.goAuth()
        }
      })
    },
    getLessonInfo() {
      for (let i in this.dataList) {
        for (let j in this.dataList[i].list) {
          for (let k in this.dataList[i].list[j].list) {
            this.coding = this.dataList[i].list[j].coding
            this.package_id = this.dataList[i].list[j].list[k].id
            this.$api.GETCATALOG({
              system_order_num: this.$route.query.order_id,
              package_id: this.dataList[i].list[j].list[k].id,
              coding: this.dataList[i].list[j].coding,
              "offcn-ticket": this.ticket,
              ticket_source: this.ticket_source,
            }).then((res) => {
              if (res.code == 0) {
                this.list = res.data.catalog.list
              } else if (res.code == 2 || res.code == 4) {
                sso.goAuth()
              }
            })
          }
        }
      }
    },
    judgetype(item, cid) {
      if (item.module_type == 1 || (item.module_type == 19 && (item.type == 0 || item.type == 1 || item.type == 3))) {
        if (item.learning_style.indexOf(2) == -1) {
          this.detail = item
          this.detail.order_id = this.$route.query.order_id
          this.detail.package_id = this.package_id
          this.detail.cid = cid
          this.detail.shopid = this.shopid
          if (this.isapplets) {
            this.applets_flag = true
          } else {
            this.zujians_flag = true
          }
        } else {
          this.$router.push({
            path: "/file",
            query: {
              order_id: this.$route.query.order_id,
              package_id: this.package_id,
              cid: cid,
              unit_id: item.menu_id,
              module_type: item.module_type,
              url: item.url
            }
          });
        }
      } else if (item.module_type == 2 || (item.module_type == 19 && item.type == 2)) {//视频
        if (item.learning_style.indexOf(2) == -1) {
          this.detail = item
          this.detail.order_id = this.$route.query.order_id
          this.detail.package_id = this.package_id
          this.detail.cid = cid
          this.detail.shopid = this.shopid
          if (this.isapplets) {
            this.applets_flag = true
          } else {
            this.zujians_flag = true
          }
        } else {
          this.$router.push({
            path: "/video",
            query: {
              order_id: this.$route.query.order_id,
              package_id: this.package_id,
              cid: cid,
              media_id: item.video_id,
              name: item.name,
              time: item.video_time,
              id: item.menu_id,
              video_source: item.video_source,
              owner: this.$route.query.owner,
              channel: this.$route.query.channel,
              orgn: this.$route.query.orgn
            }
          });
        }
      } else if (item.module_type == 4 || item.module_type == 5 || item.module_type == 20 || (item.module_type == 19 && (item.type == 4 || item.type == 8 || item.type == 20))) {
        if (this.isapplets) {
          this.applets_flag = true
        } else {
          this.zujian_flag = true
          this.$nextTick(() => {
            var btn = document.getElementById('launch-btn')
            btn.addEventListener('launch', function(e) {
              this.handleJudgeWechat(); //是否满足跳转app条件
            });
          })
        }
      } else if (item.module_type == 6 && item.operator == 2) {
        let time = parseInt(new Date().getTime() / 1000);
        let url
        if (item.is_playback == 1) {
          url = item.playback_url.replace('http:', '')
        } else {
          url = item.live_url.replace('http:', '')
        }
        if (time > item.end_time + 3600 && item.is_playback != 1) {
          Toast("直播已结束");
        } else if (time < item.start_time - 3600) {
          Toast("直播未开始");
        } else if (item.is_playback == 1) {
          location.href = url
          // this.$router.push({
          //   path: "/livevod",
          //   query: {
          //     order_id: item.system_order,
          //     package_id: this.package_id,
          //     cid: cid,
          //     unit_id: item.menu_id,
          //     live_type: 1,
          //     module_type: 66,
          //     url: url
          //   }
          // })
        } else {
          location.href = url
          // this.$router.push({
          //   path: "/livevod",
          //   query: {
          //     order_id: item.system_order,
          //     package_id: this.package_id,
          //     cid: cid,
          //     unit_id: item.menu_id,
          //     live_type: 1,
          //     module_type: 6,
          //     url: url
          //   }
          // })
        }
      } else if (item.module_type == 6 || (item.module_type == 19 && item.type == 6)) {
        if (item.learning_style.indexOf(2) == -1) {
          this.detail = item
          this.detail.order_id = this.$route.query.order_id
          this.detail.package_id = this.package_id
          this.detail.cid = cid
          this.detail.shopid = this.shopid
          if (this.isapplets) {
            this.applets_flag = true
          } else {
            this.zujian_flag = true
          }
        } else {
          let time = parseInt(new Date().getTime() / 1000);
          if (time > item.end_time + 3600 && item.is_playback != 1) {
            Toast("直播已结束");
          } else if (time < item.start_time - 3600) {
            Toast("直播未开始");
          } else if (item.is_playback == 1) {
            this.$router.push({
              path: "/livevod",
              query: {
                order_id: this.$route.query.order_id,
                package_id: this.package_id,
                cid: cid,
                unit_id: item.menu_id,
                live_type: 3,
                module_type: 66,
                url: item.live_record_url
              }
            })
          } else {
            this.$router.push({
              path: "/livevod",
              query: {
                order_id: this.$route.query.order_id,
                package_id: this.package_id,
                cid: cid,
                unit_id: item.menu_id,
                live_type: 3,
                module_type: 6,
                url: item.live_record_url
              }
            })
          }
        }
      } else if (item.module_type == 7 || (item.module_type == 19 && item.type == 7)) {
        this.handout_flag = true;
        this.handoutlist = item;
        this.handoutcid = cid
        this.handoutpack = this.package_id
      } else if (item.module_type == 9) {
        if (this.isapplets) {
          this.applets_flag = true
        } else {
          this.zujian_flag = true
          this.$nextTick(() => {
            var btn = document.getElementById('launch-btn')
            btn.addEventListener('launch', function(e) {
              this.handleJudgeWechat(); //是否满足跳转app条件
            });
          })
        }
      }
    },
    parent() {
      this.handout_flag = false;
    },
    popup() {
      this.applets_flag = false;
    },
    goapp() {
      this.zujians_flag = false;
    },
    cancel_flag() {
      this.zujian_flag = false
    },
    search_flag() {
      if(!this.isweixin){
        this.arshow = false;
        if (this.sf == 'zxkt' || this.sf == 'zgwx') {
          this.openApp('https://www.eoffcn.com/wx_classonline/detail/?type=1&sso_id='+this.ssoid+'&orderSn='+ this.sn +'&spuID='+ this.shopid +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn);
        } else if (this.sf == 'zgtk') {
          this.openApp('https://www.eoffcn.com/zg_questions/detail/?type=1&sso_id='+this.ssoid+'&orderSn='+ this.sn +'&spuID='+ this.shopid +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn)
        } else if (this.sf == 'sydw') {
          this.openApp('https://3min-class.offcn.mobi/institution/?type=1&sso_id='+this.ssoid+'&orderSn='+ this.sn +'&spuID='+ this.shopid +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn)
        } else if (this.sf == 'zgzsb') {
          this.openApp('https://www.eoffcn.com/zg_zsb/detail/?type=1&sso_id='+this.ssoid+'&orderSn='+ this.sn +'&spuID='+ this.shopid +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn)
        } else if (this.sf == 'zgyljy') {
          location.href = 'https://www.eoffcn.com/zg_yikao/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.shopid +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgky') {
          location.href = 'https://www.eoffcn.com/zg_postgraduate/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.shopid +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgjsgc') {
          this.openApp('//www.zggcks.com/zg/2021jgapp/')
        } else if (this.sf == 'zgyouzhi') {
          if (this.android) {
              var SERVER_BASE_URL
              if (process.env.NODE_ENV=='production') {
                SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
              } else {
                SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
              }
              this.openApp(SERVER_BASE_URL);
            } else if (this.ios) {
              location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=1&orderSn=' + this.sn + '&spuID=' + this.shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
        } else {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            } else {
              SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=1&orderSn=' + this.sn + '&spuID=' + this.shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
          }
        }
      }else{
        this.arshow = true;
      }
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    }
  }
};
</script>

<style lang="less">
#launch-btn {
  position: absolute;
  right: 0;
  width: 242px;
  height: 68px;
  opacity: 0;
}
.leaf-course {
  padding: 0 30px;
  background: #fff;
  .class_block {
    margin-bottom: 40px;
    .tit {
      font-size: 24px;
      font-weight: bold;
    }
  }
  .parent-list {
    img {
      width: 30px;
      height: 30px;
      margin-right: 15px;
      margin-top: 10px;
      &.video {
        width: 44px;
        height: 42px;
      }
      &.write {
        width: 43px;
        height: 44px;
      }
      &.doc {
        width: 45px;
        height: 49px;
      }
      &.handout {
        width: 46px;
        height: 45px;
      }
    }
    .com-child {
      display: flex;
      align-items: center;
      margin-top: 40px;
    }
    .title {
      font-size: 28px;
      color: #333;
    }
    .other-msg {
      color: #999;
      font-size: 20px;
      margin-top: 10px;
      display: flex;
      align-items: center;
    }
  }
  .class_dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 2;
    .dialog_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 490px;
      line-height: 40px;
      border-radius: 18px;
      transform: translate(-50%, -50%);
      background: #fff;
      .dialog_message {
        text-align: center;
        padding: 30px 30px;
      }
      p {
        display: flex;
        border-top: 1px solid #e5e5e5;
        height: 70px;
        line-height: 70px;
        span {
          flex: 1;
          text-align: center;
        }
        .goapp {
          color: #e60012;
          border-left: 1px solid #e5e5e5;
          a {
            color: #e60012;
          }
        }
      }
    }
  }
  .handout_assembly {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    .handout_content {
      position: absolute;
      top: 30%;
      overflow: auto;
    }
  }
  .popop_content {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .placeline{
    width: 1px;
    height: 26px;
    background: #999999;
    display: inline-block;
    margin: 0 18px;
  }
  .sf {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leaf/index.vue